import classNames from "classnames";

import RcaNavCheckIcon from "@components/Icons/Rca/RcaNavCheckIcon";

const RCA_NAV_STEPS = [
  { stepId: 1, label: "Informatii salvate" },
  { stepId: 2, label: "Proprietar" },
  { stepId: 3, label: "Vehicul" },
  { stepId: 4, label: "Data polita" },
  { stepId: 5, label: "Oferte" },
];

const RCAStepNav = ({ currentStep, onStepChange, hasSavedVehicles }) => (
  <div className="overflow-x-auto pb-[16px]">
    <div className="flex items-center justify-center space-x-[28px] min-w-max">
      {RCA_NAV_STEPS.map(({ stepId, label }) => {
        const isActive = currentStep === stepId;
        const prevStep = stepId < currentStep;
        const shouldHideFirstStep = stepId === 1 && !hasSavedVehicles;

        if (shouldHideFirstStep) {
          return null;
        }

        return (
          <button
            key={stepId}
            type="button"
            onClick={() => onStepChange(stepId)}
            disabled={!prevStep && !isActive}
            className={classNames(
              "flex flex-col md:flex-row items-center flex-shrink-0 py-[4px] md:py-[8px] md:px-[16px] md:rounded-[4px] transition-all",
              {
                "md:border md:border-black": isActive,
                "md:bg-[#FAFAFA]": !isActive,
                "cursor-pointer hover:bg-gray-100": prevStep,
                "cursor-not-allowed": !prevStep && !isActive,
              }
            )}
          >
            {/* Step indicator circle */}
            <div
              className={classNames(
                "w-5 h-5 rounded-full flex items-center justify-center mr-2 flex-shrink-0",
                {
                  "bg-primary border border-black": isActive || prevStep,
                  "bg-white border-2 border-[#808080]": !isActive && !prevStep,
                }
              )}
            >
              {prevStep && <RcaNavCheckIcon />}
            </div>

            <span
              className={classNames(
                "text-[12px] md:text-base font-medium whitespace-nowrap",
                {
                  "text-black font-medium": isActive || prevStep,
                  "text-[#808080]": !isActive && !prevStep,
                }
              )}
            >
              {label}
            </span>
          </button>
        );
      })}
    </div>
  </div>
);

export default RCAStepNav;
